import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './LikeDislikeProject.scss';

const toastMessage = () => (
  <div className="body-text-2 g-row--always">
    <i className="fas fa-check-circle me-4" />
    <span className="d-none d-md-block">
      Got it! We&#39;ll use this info to make better project recommendations.
    </span>
    <span className="d-block d-md-none body-text-3">We’ll use this to make better recommendations.</span>
  </div>
);

class LikeDislikeProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHoveringOverLike: false,
      isHoveringOverDislike: false,
      liked: props.liked,
      disliked: props.disliked,
    };
    this.handleMouseOverLike = this.handleMouseOverLike.bind(this);
    this.handleMouseLeaveLike = this.handleMouseLeaveLike.bind(this);
    this.handleMouseOverDislike = this.handleMouseOverDislike.bind(this);
    this.handleMouseLeaveDislike = this.handleMouseLeaveDislike.bind(this);
    this.like = this.like.bind(this);
    this.dislike = this.dislike.bind(this);
  }

  handleMouseOverLike() {
    this.setState({ isHoveringOverLike: true, isHoveringOverDislike: false });
  }

  handleMouseLeaveLike() {
    this.setState({ isHoveringOverLike: false });
  }

  handleMouseOverDislike() {
    this.setState({ isHoveringOverLike: false, isHoveringOverDislike: true });
  }

  handleMouseLeaveDislike() {
    this.setState({ isHoveringOverDislike: false });
  }

  like() {
    const {
      id, name, likePath, csrfToken,
    } = this.props;
    return postRequest(
      likePath,
      {
        project_id: id,
      },
      csrfToken,
    ).then(() => {
      analyticsTrack('Liked an LikeDislikeProject', {
        location: 'Opportunities Index View',
        id,
        project_name: name,
      });
      this.setState({ liked: true, disliked: false });
      toast.success(toastMessage);
    });
  }

  dislike() {
    const {
      id, name, dislikePath, csrfToken,
    } = this.props;
    return postRequest(
      dislikePath,
      {
        project_id: id,
      },
      csrfToken,
    ).then(() => {
      analyticsTrack('Disliked an LikeDislikeProject', {
        location: 'Opportunities Index View',
        id,
        project_name: name,
      });
      this.setState({ liked: false, disliked: true });
      toast.success(toastMessage);
    });
  }

  render() {
    const {
      liked, disliked, isHoveringOverLike, isHoveringOverDislike,
    } = this.state;

    return (
      <div
        className="like-dislike-container"
        role="button"
        tabIndex={0}
      >
        <ToastContainer
          position="top-center"
          transition={Slide}
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
        />

        <div className="like-dislike">
          <div className="d-none d-md-block">Would you like to see more projects like this one?</div>
          <div className="d-block d-md-none body-text-3">Want to see more projects like this?</div>
          <i
            className={`ms-3 fa${(liked || isHoveringOverLike) ? 's' : 'r'} fa-thumbs-up fa-flip-horizontal`}
            onMouseOver={this.handleMouseOverLike}
            onFocus={this.handleMouseOverLike}
            onMouseLeave={this.handleMouseLeaveLike}
            onClick={() => this.like()}
            role="button"
            tabIndex={0}
          />
          <i
            className={`ms-3 fa${(disliked || isHoveringOverDislike) ? 's' : 'r'} fa-thumbs-down`}
            onMouseOver={this.handleMouseOverDislike}
            onFocus={this.handleMouseOverDislike}
            onMouseLeave={this.handleMouseLeaveDislike}
            onClick={() => this.dislike()}
            role="button"
            tabIndex={0}
          />
        </div>
      </div>
    );
  }
}

LikeDislikeProject.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  likePath: PropTypes.string.isRequired,
  dislikePath: PropTypes.string.isRequired,
  liked: PropTypes.bool,
  disliked: PropTypes.bool,
};

LikeDislikeProject.defaultProps = {
  liked: false,
  disliked: false,
};

export default LikeDislikeProject;
